export default __webpack_public_path__ + "static/media/fitfor55.5dabf20c.png";